import { useNavigation, useRoute } from "@react-navigation/native";
import { useEffect } from "react";
export function useContactsPickerResult(callback) {
    var setParams = useNavigation().setParams;
    // eslint-disable-next-line
    var _useRoute = useRoute(), name = _useRoute.name, params = _useRoute.params;
    useEffect(function() {
        if (params === null || params === void 0 ? void 0 : params._contactPickerResult) {
            var contactPickerResult = params._contactPickerResult;
            // @ts-expect-error
            setParams({
                _contactPickerResult: undefined
            });
            callback(contactPickerResult);
        }
    }, [
        setParams,
        params === null || params === void 0 ? void 0 : params._contactPickerResult,
        callback
    ]);
    return name;
}
